













import { Vue, Component } from "./vue-ext";
import Router from "./router/router";
// import BaseView from "./views/BaseView";
import Service, { IService } from "./service/Service";
import config from "./config";
import mixins from "vue-class-component";
import { HousingCompany, Account, User, Message, ResponseBase, ParkingSlotType, Material, FileType, OwnInfo, Sauna, ParkingArea, RemoteNotification, Request } from "./models";
import xamatron from "./lib/xamatron";
import "./components/OkPopup";
// import MetaInfo from "vue-meta";

export interface IApp {
    setTitle(title: string): void;
    setIconClass(iconClass: string): void;
    service: IService;
    title: string | null;
    iconClass: string | null;
    setHousingCompany(housingCompany: HousingCompany, makePost: boolean): void;
    getCurrentHousingCompany(): HousingCompany | null;
    getCurrentAccount(): Account | null;
    getCurrentUser(): User | null;
    // getParkingSlotTypeClass(type: ParkingSlotType): string;
    // setUser(user: User): void;
    authenticate(): Promise<boolean>;
    isAuthenticated(): boolean;
    isEmptyOrWhiteSpace(str: string | null): boolean;
    updateMessages(): Promise<Message[]>;
    updateRequests(): Promise<Request[]>;
    // getMessages(): Message[];
    getMessage(id: number): Message | null;
    getRequest(id: number): Request | null;
    getUnreadMessageCount(): number;
    getUnreadRequestCount(): number;
    updateAllOwnMessages(): Promise<Message[]>;
    // getAllOwnMessages(): Message[];
    updateMaterials(): Promise<Material[]>;
    // getMaterials(): Material[];
    getMaterial(id: number): Material | null;
    getFileType(extension: string): FileType;
    setCurrentOwnInfo(ownInfo: OwnInfo | null): void;
    // getCurrentOwnInfo(): OwnInfo | null;
    setOkPopupOpen(open: boolean, text?: string): void;
    downloadUrl(url: string, fileName: string): void;
    openUrl(url: string): void;
    back(): void;
    logOut(): void;
    saunas: Sauna[] | null;
    parkingAreas: ParkingArea[] | null;
    ownInfo: OwnInfo | null;
    messages: Message[];
    allOwnMessages: Message[];
    materials: Material[];
    requests: Request[];
}

// <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
@Component({
    router: Router.getRouter(),
    // metaInfo(): MetaInfo {
    //     return {
    //         // title: "This my title yah!",
    //         meta: [
    //             { name: "viewport", content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" }
    //         ]
    //     }
    // }
})
export default class App extends Vue implements IApp {
    private baseService: IService | null = null;
    private housingCompany: HousingCompany | null = null;
    private account: Account | null = null;
    private user: User | null = null;
    public title: string | null = null;
    public iconClass: string | null = null;
    public messages: Message[] = [];
    public allOwnMessages: Message[] = [];
    public materials: Material[] = [];
    public ownInfo: OwnInfo | null = null;
    private okPopupText: string = "";
    private okPopupOpen: boolean = false;
    public saunas: Sauna[] | null = null;
    public parkingAreas: ParkingArea[] | null = null;
    private remoteNotifications: RemoteNotification[] = [];
    public requests: Request[] = [];

    public async created() {
        console.log("App.vue created");
        this.baseService = new Service(config.apiUrl, this.logOut, this.onError);
        xamatron.setBackButtonHandler(() => this.back());
        xamatron.setRemoteNotificationHandler((data) => this.handleRemoteNotification(data));
        this.$router.push("/");
        console.log("App.vue created END"); 
    }

    private handleRemoteNotification(data: any) {
        console.log("push arrived: " + JSON.stringify(data));
        this.remoteNotifications.push({ subject: data.title, message: data.body });
        this.updateAll();

        setTimeout(() => {
            this.remoteNotifications.pop();
        }, 5000);
    }

    public back() {
        if (this.$route.name === "ChooseHousingCompanyView") {
            xamatron.exitApplication();
        } else {
            this.$router.back();
        }
    }

    private updateAll() {
            setTimeout(async () => {
                await this.updateMessages();
                await this.updateMaterials();
                await this.updateSaunas();
                await this.updateParkingAreas();
                await this.updateRequests();
            }, 100);
    }

    public setTitle(title: string) {
        this.title = title;
    }

    public setIconClass(iconClass: string) {
        this.iconClass = iconClass;
    }

    public async setHousingCompany(housingCompany: HousingCompany, makePost: boolean = true) {
        if (this.isAuthenticated()) {
            this.housingCompany = housingCompany;

            if (!makePost) {
                return;
            }

            this.user = await this.service.user.SetHousingCompany(this.housingCompany.housingCompanyId);
            
            if (this.user && this.housingCompany) {
                this.account = this.user.accounts.find(a => a.housingCompanyId === this.housingCompany!.housingCompanyId) as Account;

                this.updateAll();
                // setTimeout(async () => {
                //     if (this.housingCompany) {
                //         this.saunas = await this.service.sauna.GetSaunas(this.housingCompany.housingCompanyId);
                //         this.parkingAreas = await this.service.parking.GetParkingAreas(this.housingCompany.housingCompanyId);
                //     }
                // }, 100);
            } else {
                this.$router.push("/");
            }
        }
    }

    private async updateSaunas() {
         if (this.housingCompany) {
            this.saunas = await this.service.sauna.GetSaunas(this.housingCompany.housingCompanyId);
        }
    }

    private async updateParkingAreas() {
        if (this.housingCompany) {
            this.parkingAreas = await this.service.parking.GetParkingAreas(this.housingCompany.housingCompanyId);
        }
    }

    public getCurrentHousingCompany(): HousingCompany | null {
        if (this.housingCompany === null || this.housingCompany === undefined) {
            this.$router.push("/");
        }

        return this.housingCompany;
    }


    public getCurrentAccount(): Account | null {
        if (!this.account) {
            this.account = { 
                firstName: "",
                lastName: "",
                streetAddress: "",
                zipCode: "",
                city: "",
                ssn: "", 
                accountId: 0, 
                email: "", 
                phone: "", 
                housingCompanyId: 0, 
                isVerified: false,
                isCompany: false,
                companyName: "",
                displayName: ""
            };
        }

        return this.account;
    }

    // public setUser(user: User): void {
    //     this.user = user;
    //     localStorage.setItem("user", JSON.stringify(user));
    // }
    public async authenticate(): Promise<boolean> {
        let pushToken = null;
        // xamatron.registerForRemoteNotifications().then(function (res) {
        //     this.pushToken = res.token as string;
        // });
        try {
            console.log("calling xamatron.registerForRemoteNotifications");
            pushToken = (await xamatron.registerForRemoteNotifications()).token;
            console.log("finished xamatron.registerForRemoteNotifications. token: " + pushToken);
        } catch (err) {
            console.log("error at xamatron.registerForRemoteNotifications: " + err);
        }

        const response = await this.service.authentication.authenticate(xamatron.deviceId, pushToken);

        if (!response.isError) {
            this.user = response.user;
            return true;
        } else {
            return false;
        }
    }

    public getCurrentUser(): User | null {
        if (!this.user) {
            this.user = { userId: 0, firstName: "", lastName: "", email: "", phone: "", streetAddress: "", zipCode: "", city: "", accounts: [], ssn: "", isCompany: false, businessId: null, companyName: "", displayName: "" };
        }

        return this.user;
    }

    public isAuthenticated(): boolean {
        return !!this.user && this.user.userId > 0;
    }

    public isEmptyOrWhiteSpace(str: string | null) {
        return !(str && str.replace(/ /g, "").length > 0);
    }

    public async updateMessages() {
        let allMessages = await this.updateAllOwnMessages();
        if (this.housingCompany) {
            this.messages = allMessages.filter(m => m.housingCompanyId === this.housingCompany!.housingCompanyId);
            // this.messages = await this.service.message.GetMessagesByHousingCompany(this.housingCompany.housingCompanyId);
            // this.unreadMessagesCount = this.getUnreadMessageCount();
        }

        return this.messages;
    }

    // public getMessages() {
    //     return this.messages;
    // }

    public getMessage(id: number) {
        if (this.messages) {
            return this.messages.find(m => m.messageId === id) as Message;
        }

        return null;
    }

      public getRequest(id: number) {
        if (this.requests) {
            return this.requests.find(m => m.requestId === id) as Request;
        }

        return null;
    }
    
    public getUnreadMessageCount() {
        return this.messages.filter(m => m.readOn === null).length;
    }

    public getUnreadRequestCount() {
        return this.requests.filter(m => m.readOn === null).length;
    }
    
    private _allOwnMessagesUpdating = false;
    public async updateAllOwnMessages() {
        try {
            if (!this._allOwnMessagesUpdating) {
                this._allOwnMessagesUpdating = true;
                this.allOwnMessages = [];
                let housingCompanyIdsDone: number[] = [];

                if (this.user && this.user.accounts && this.user.accounts.length > 0) {
                    for (let i = 0; i < this.user.accounts.length; i++) {
                        if (housingCompanyIdsDone.filter(id => id === this.user!.accounts[i].housingCompanyId).length > 0) {
                            continue;
                        }

                        let messages = await this.service.message.GetMessagesByHousingCompany(this.user.accounts[i].housingCompanyId);

                        for (let j = 0; j < messages.length; j++) {
                            this.allOwnMessages.push(messages[j]);
                        }

                        housingCompanyIdsDone.push(this.user.accounts[i].housingCompanyId);
                    }
                }
            }
        } catch {

        } finally {
            this._allOwnMessagesUpdating = false;
        }
        
        
        return this.allOwnMessages;
    }

    // public getAllOwnMessages() {
    //     return this.allOwnMessages;
    // }

    public async updateMaterials() {
        if (this.account) {
            this.materials = await this.service.material.GetMaterials(this.account.accountId);
        }

        return this.materials;
    }

    // public getMaterials() {
    //     return this.materials;
    // }

    public getMaterial(id: number) {
        if (this.materials) {
            return this.materials.find(m => m.materialId === id) as Material;
        }

        return null;
    }

    public async updateRequests() {
        this.requests = await this.service.request.GetRequests();
        
        return this.requests;
    }

    public logOut() {
        localStorage.authToken = "";
        this.user = null;
        this.account = null;
        this.housingCompany = null;
        this.$router.push("/"); 
    }

    public onError(res: ResponseBase) {
        if (res.isError) {
            this.okPopup(res);
        }
    }

    private okPopup(res: ResponseBase) {
        let popupText = this.$t("errorCodes." + res.errorCode) as string;

        if (popupText.indexOf("errorCodes.") !== -1) {
            popupText = this.$t("errorCodes.Unrecognized") as string;
        }

        this.okPopupText = popupText;
        this.setOkPopupOpen(true);
    }

    public getFileType(extension: string): FileType {
         switch (extension) {
            case ".pdf":
                return FileType.Pdf;
            case ".xls":
            case ".xlsx":
            case ".xlsm":
                return FileType.Excel;
            case ".docx":
                return FileType.Word;
            default: 
                return FileType.Default;
        }
    }

    public setCurrentOwnInfo(ownInfo: OwnInfo | null): void {
        this.ownInfo = ownInfo;
    }

    // public getCurrentOwnInfo(): OwnInfo | null {
    //     return this.ownInfo;
    // }

    public setOkPopupOpen(open: boolean, text?: string) {
        if (text) {
            this.okPopupText = text;
        }
        
        this.okPopupOpen = open;
    }
    
    public async downloadUrl(url: string, fileName: string) {
        await xamatron.downloadURL(url, fileName);
    }

    public async openUrl(url: string) {
        await xamatron.openURL(url);
    }
}

